import i18n from "@/language/i18n";
import WAREHOUSE_WIDGETS from "../widgets/WAREHOUSE_WIDGETS";
import INVENTORY_WIDGETS from '../widgets/INVENTORY_WIDGETS'

const WAREHOUSE_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    STORAGE_MODULE_WINDOW_ID: 'storageelements',
    WAREHOUSE_TYPES_MODULE_WINDOW_ID: 'storageorganizationtypes',
    STOCK_MODULE_WINDOW_ID: 'storageelementstock',
    STOCK_MOVEMENT_WINDOW_ID: 'stockmovement',
    INVENTORY_WINDOW_ID: 'stocktaking',
    COMPANY_LOCATIONS_MODULE_WINDOW_ID: 'companylocations',
});

export { WAREHOUSE_MODULE_WINDOW_IDENTIFIER };

export default {
    WAREHOUSE_GROUP_WRAPPER: {
        type: 'group',
        id: 'storage',
        label: i18n.t('ModuleRegistry.groups.warehouse.name'),
        children: [],
        icon: '$wProductStorage',
        sidebarIcon: '$wNavWarehouseManagement'
    },
    CHILDREN: {
        STORAGE_MODULE: {
            type: 'module',
            id: 'storageelements',
            windowIdentifierType: WAREHOUSE_MODULE_WINDOW_IDENTIFIER.STORAGE_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.warehouse.organisation.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/storageelements',
            globalSearch: {
                index: 'storageelements',
                presentation: i18n.t('ModuleRegistry.groups.warehouse.organisation.presentation'),
                component: 'StorageUnitItem.vue',
                shortcut: '-p'
            },
            widgets: WAREHOUSE_WIDGETS.STORAGE_ELEMENT_WIDGETS
        },
        WAREHOUSE_TYPES_MODULE: {
            type: 'module',
            id: 'storageorganizationtypes',
            windowIdentifierType: WAREHOUSE_MODULE_WINDOW_IDENTIFIER.WAREHOUSE_TYPES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.warehouse.organisationTypes.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/storageorganizationtypes',
            globalSearch: {
                index: 'storageorganizationtypes',
                presentation: i18n.t('ModuleRegistry.groups.warehouse.organisationTypes.presentation'),
                component: 'StorageOrganisationTypesItem.vue',
                shortcut: '-t'
            },
            widgets: WAREHOUSE_WIDGETS.STORAGE_ORGANIZATION_WIDGETS
        },
        STOCK_MODULE: {
            type: 'module',
            id: 'storageelementstock',
            windowIdentifierType: WAREHOUSE_MODULE_WINDOW_IDENTIFIER.STOCK_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.warehouse.stock.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/storageelementstock',
            globalSearch: {
                index: 'storageelementstock',
                presentation: i18n.t('ModuleRegistry.groups.warehouse.stock.presentation'),
                component: 'ProductStockItem.vue',
                shortcut: '-t'
            },
            widgets: WAREHOUSE_WIDGETS.STORAGE_STOCK_WIDGETS
        },
        STOCK_MOVEMENT: {
            type: 'module',
            hidden: true,
            windowIdentifierType: WAREHOUSE_MODULE_WINDOW_IDENTIFIER.STOCK_MOVEMENT_WINDOW_ID,
        },
        INVENTORIES_MODULE: {
            type: 'module',
            id: 'stocktaking',
            label: i18n.t('ModuleRegistry.groups.warehouse.inventory.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/stocktaking',
            widgets: INVENTORY_WIDGETS.INVENTORY_WIDGETS,
            globalSearch: {
                index: 'stocktaking',
                presentation: i18n.t('Common.inventory'),
                component: 'StockTakingItem.vue',
                shortcut: '-t'
            },
        },
        // ORDERS_MODULE: {
        //     type: 'module',
        //     id: 'orders',
        //     label: i18n.t('ModuleRegistry.groups.orders.name'),
        //     navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
        //     routerLink: '/orders',
        // },
        // ORDER_SUGGESTIONS_MODULE: {
        //     type: 'module',
        //     id: 'externalDemands',
        //     label: i18n.t('ModuleRegistry.groups.warehouse.orderSuggestions.label'),
        //     navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
        //     routerLink: '/externalDemands',
        // },
        PROCUREMENTS_MODULE: {
            type: 'module',
            id: 'internalDemands',
            label: i18n.t('ModuleRegistry.groups.warehouse.procurements.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/internalDemands',
        },
        STORAGE_ORDERS_MODULE: {
            type: 'module',
            id: 'storageOrders',
            label: i18n.t('ModuleRegistry.groups.warehouse.storageOrders.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/storageOrders',
        },
        COMPANY_LOCATIONS_MODULE: {
            type: 'module',
            id: 'companylocations',
            windowIdentifierType:
            WAREHOUSE_MODULE_WINDOW_IDENTIFIER.COMPANY_LOCATIONS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.warehouse.companyLocationsOverview.label'),
            navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
            routerLink: '/companylocations',
            globalSearch: {
                index: 'companylocations',
                presentation: i18n.t('ModuleRegistry.groups.warehouse.companyLocationsOverview.label'),
                component: 'CompanyLocationItem'
            },
        },
    }
}
